<template>
  <div class="contacts-plate">
    <h3 class="contacts-plate__title">
      Наш офис
    </h3>

    <address class="contacts-plate__address">
      <ul class="contacts-plate__address-list">
        <li class="contacts-plate__address-list-item">
          <app-svg
            id="location"
            width="19"
            height="22"
          />
          {{ data[0].address }}
        </li>
        <li class="contacts-plate__address-list-item">
          <app-svg
            id="phone"
            width="20"
            height="22"
          />
          <a
            :href="'tel:' + data[0].phone.replaceAll(' ', '')"
            class="contacts-plate__go"
          >{{ data[0].phone }}</a>
        </li>
        <li class="contacts-plate__address-list-item">
          <app-svg
            id="email"
            width="21"
            height="19"
          />
          <a
            :href="'mailto:' + data[0].email.replaceAll(' ', '')"
            class="contacts-plate__email"
          >{{ data[0].email }}</a>
        </li>
      </ul>
    </address>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: [Array, Object],
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-plate {
  $that: &;

  &__title {
    font-size: 20px;
    line-height: 26px;
    padding-bottom: 30px;
  }

  &__address {
  }

  &__address-list {
  }

  &__address-list-item {
    font-size: 18px;
    line-height: 26px;
    color: $color_dark-90;
    display: flex;
    font-style: normal;

    svg {
      flex: none;
      margin-right: 12px;
      color: $color_primary;
      transform: translate3d(0, 2px, 0);
    }

    &:last-child svg {
      transform: translate3d(0, 5px, 0);
    }

    & + & {
      padding-top: 22px;
    }
  }

  &__go {
    color: inherit;

    &:hover {
      color: $color_primary;
    }
  }

  &__email {
  }
}
</style>
